<div class="nav-menu__container">
  <div *ngFor="let item of menuItems" class="nav-menu__item" [routerLink]="item.route"
       routerLinkActive="nav-menu__selected" [routerLinkActiveOptions]="{exact: item.exact}">
    <div class="material-icons nav-menu__icon">{{item.icon}}</div>
    <div class="nav-menu__label">{{item.name}}</div>
  </div>
</div>
